import React from 'react'
import {
  Card,
  CardHeader,
  Table
} from 'reactstrap'
import PriceUtil from 'utils/price-util'
import PropTypes from 'prop-types'
import { PRODUCT_TYPES } from 'domains/revenue/constants'

const propTypes = {
  revenue: PropTypes.shape({
    total_price      : PropTypes.number,
    total_revenue    : PropTypes.number,
    total_commission : PropTypes.number,
    total_items      : PropTypes.number,
    items            : PropTypes.array,
    inbounds         : PropTypes.array
  })
}

const defaultProps = {
  revenue: {
    total_price      : 0,
    total_revenue    : 0,
    total_commission : 0,
    total_items      : 0,
    inbounds         : [],
    items            : []
  }
}

const findInbound = (inbounds, inbound_id) => {
  if (!inbound_id) return null
  return inbounds.find((inbound) => inbound.id == inbound_id)
}

const RevenueProductDetailCard = ({ revenue }) => (
  <Card>
    <CardHeader className='font-weight-bold'>
      { 'Products Detail' }
    </CardHeader>
    <div style={{ overflowX: 'auto' }}>
      <Table className="mb-0">
        <thead
          className='font-weight-bold text-center w-100'
          style={{ background: '#5e72e4', color: 'white' }}
        >
          <tr>
            <th>TYPE</th>
            <th>INBOUND CODE</th>
            <th>SKU</th>
            <th>NAME</th>
            <th>QTY</th>
            <th>PRICE</th>
            <th>REVENUE</th>
            <th>COMMMISSION</th>
          </tr>
        </thead>
        <tbody>
          {
            revenue.items.map((item) => (
              <tr key={ `${item.sku}-${item.sku}` }>
                <td>
                  { PRODUCT_TYPES[item.productable_type] }
                </td>
                <td>
                  { findInbound(revenue.inbounds, item.inbound_id)?.code || '-' }
                </td>
                <td>
                  { item.sku }
                </td>
                <td>
                  { item.name }
                </td>
                <td>
                  { item.qty }
                </td>
                <td>
                  { PriceUtil.format(item.sold_price) }
                </td>
                <td>
                  { PriceUtil.format(item.revenue) }
                </td>
                <td>
                  { PriceUtil.format(item.commission) }
                </td>
              </tr>
            ))
          }

          <tr className='font-weight-bold border'>
            <td colSpan='4' className='text-right'>
                TOTAL
            </td>
            <td>
              { revenue.total_items }
            </td>
            <td>
              { PriceUtil.format(revenue.total_price) }
            </td>
            <td>
              { PriceUtil.format(revenue.total_revenue) }
            </td>
            <td>
              { PriceUtil.format(revenue.total_commission) }
            </td>
          </tr>

        </tbody>
      </Table>
    </div>
  </Card>
)

RevenueProductDetailCard.propTypes    = propTypes
RevenueProductDetailCard.defaultProps = defaultProps

export default RevenueProductDetailCard
